import { VersionEvent } from '../types';
const hiddenKeys = [
    'id',
    'status',
    'status_code',
    'status_icon',
    'inspection_id',
    'fire_extinguisher_answer_id',
    'fire_extinguisher_id',
    'created_by_technician_id',
    'asset_item_id',
    'unique_id',
    'status_color',
    'frequency_id',
    'work_order_status',
    'work_order_status_id',
    'work_order_status_icon',
    'work_order_status_color',
    'inspection_type_id',
    'currency_id',
    'default_sales_person_id',
    'building_id',
    'work_order_id',
    'work_order_type_id',
    'uuid',
    'default_service_tech_id',
    'default_subcontractor_id',
    'default_tech_id',
    'tax_item_id',
    'price_list_id',
    'account_id',
    'territory_id',
    'deficiency_resolution_status_id',
    'sprinklers_code_year',
    'fire_doors_code_year',
    'fire_alarms_code_year',
    'fire_alarms_verification_code_year',
    'fire_exit_signs_code_year',
    'fire_extinguishers_code_year',
    'bill_to_account_id',
    'technician_id',
    'subcontractor_id',
    'sender_id',
    'recipient_id',
    'cost_code_id',
    'proposal_status_id',
    'email_url_uuid',
    'proposal_type_id',
    'pdf_file_name',
    'pdf_content_type',
    'pdf_file_size',
    'pdf_updated_at',
    'pdf_status',
    'approved',
    'invoice_category_id',
    'tenant_id',
    'invoicing_ledger_item_id',
    'payment_term_id',
    'visit_status',
    'visit_status_name',
    'visit_status_color',
    'visit_status_icon',
    'assignee_type',
    'visitable_id',
    'settings'
];
export default function getVersionDetails(activity) {
    if ('notes' in activity) {
        return [];
    }
    const version = activity;
    const details = Object.entries(version.changes)
        .map(([key, [oldValue, newValue]]) => {
        return { key, oldValue, newValue };
    })
        .filter(({ key, oldValue, newValue }) => !hiddenKeys.includes(key) && (newValue || version.event !== VersionEvent.Create) && (!!oldValue || !!newValue));
    return details;
}
